import script from "./team.vue?vue&type=script&lang=ts&setup=true"
export * from "./team.vue?vue&type=script&lang=ts&setup=true"

import "./team.vue?vue&type=style&index=0&id=544126e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-544126e5"]])

export default __exports__